import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { TaskReviewedMarks } from "./getTaskReviewed";

/**
 * 確認済みを全置換で保存する。
 *
 * 差分にすると、同じタスクを 2 人が開いているときの競合解決を画面が持つことになる。全置換なら
 * 後勝ちを明示的に扱える。**Web コンソールと同じ口を叩く**ので、どちらで付けても同じ記録に
 * なる（[[2026-09-10 設計ノート アドイン 生成結果画面の結果情報対応]]）。
 *
 * 読みはサブリソースだが、書きは第一階層に親 id を含める（`API設計規則`）。`projectId` は body。
 */
export async function putTaskReviewed(
    projectId: string,
    taskId: string,
    targetRefs: string[]
): Promise<TaskReviewedMarks> {
    const res = await fetchWithAuth(`/generation-reviewed/${encodeURIComponent(taskId)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ projectId, targetRefs }),
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "確認済みの記録を保存できませんでした");
    const body = (await res.json()) as { reviewed: TaskReviewedMarks };
    return body.reviewed;
}
